import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import ReporterSearch from './reporter_search';

function TopLevelSearch({
                          algoliaAppId, algoliaSearchKey, isAdmin, indexName, query,
                        }) {
  return (
    <ErrorBoundary>
      <ReporterSearch
        algoliaAppId={algoliaAppId}
        algoliaSearchKey={algoliaSearchKey}
        isAdmin={isAdmin}
        indexName={indexName}
        query={query}
      />
    </ErrorBoundary>
  );
}

TopLevelSearch.propTypes = {
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  indexName: PropTypes.string.isRequired,
  query: PropTypes.string,
};

TopLevelSearch.defaultProps = {
  query: null,
};

export default TopLevelSearch;
